import React from 'react';
import TransactionList from '@/components/TransactionList';

const TransactionsPage: React.FC = () => {
  return <TransactionList />;
};

export default TransactionsPage;
